<template>
  <Popover ref="discountPopover" :showHeader="true" headerTitle="Discount">
    <div class="order-item-popover-content">
      <FormInputText type="number" ref="discountRateEntry" :value="value" @input="$emit('update', $event)" placeholder="Discount Rate" addon="%" />
    </div>
  </Popover>
</template>


<script>
import _ from 'lodash'
import Popover from '@/components/popover.vue'

export default {
  name: 'OrderItemDiscountPopover',
  model: {
    event: 'update'
  },
  components: {
    Popover
  },
  props: {
    value: [String, Number]
  },
  methods: {
    displayFromElement(element) {
      this.$refs.discountPopover.displayFromElement(element)

      this.$nextTick(() => {
        this.$refs.discountRateEntry.select()
        this.$refs.discountRateEntry.focus()
      })
    }
  }
}
</script>